import React, { useState, useEffect, useContext } from "react";
import AddNewLinkRegular from "../addNewLinkRegular/AddNewLinkRegular";
import "./Links.css";

import { RootContext } from "../../RootContextProvider";
import { getLinksByPageID } from "../../utils/links";
import Pagelink from "../pageLink/PageLink";

import { Spin } from "antd";
import { WarningOutlined } from "@ant-design/icons";

import ModalLinkCreation from "../ModalLinkCreation/ModalLinkCreation";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { updateLink } from "../../utils/links";
import ModalUpgradeLinks from "../Locker/ModalUpgradeLinks";

const Blocks = () => {
  const { pages, links, setLinks, account } = useContext(RootContext);
  const [currentLinks, setCurrentLinks] = useState([]);
  const [currentLinkType, setCurrentLinkType] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [linkEditDetails, setLinkEditDetails] = useState();
  const [isEdittingLink, setEdittingLink] = useState(false);
  const [displayBlockPicker, setDisplayBlockPicker] = useState(true);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    // get links by pages and accountID
    const getLinksByPage = async () => {
      const links = await getLinksByPageID(pages.PageID);
      setLinks(links);
      setCurrentLinks(links);
      setLoading(false);
    };

    try {
      getLinksByPage();
    } catch (err) {
      console.log(err);
    }
    // eslint-disable-next-line
  }, [refresh, pages]);

  const modalEdit = (linkDetails) => {
    setLinkEditDetails(linkDetails);
    setEdittingLink(true);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setEdittingLink(false);
  };

  const getStyle = (style, snapshot) => {
    if (!snapshot.isDropAnimating) {
      return style;
    }
    // patching the existing style
    return {
      ...style,
      transition: `0.10s ease-out`,
      // transitionDuration: `0.08s`,
    };
  };

  const onDragEnd = async (result) => {
    //TODO
    const { destination, source } = result;
    if (!destination) {
      return;
    }
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    const newLinks = Array.from(currentLinks);
    newLinks.splice(source.index, 1);
    newLinks.splice(destination.index, 0, currentLinks[source.index]);
    for (let i = 0; i < newLinks.length; i++) {
      newLinks[i].LinkIndex = i;
      let linkIndex = {
        LinkID: newLinks[i].LinkID,
        LinkIndex: newLinks[i].LinkIndex,
      };
      updateLink(pages.PageID, linkIndex);
    }
    setLinks(newLinks);
    setCurrentLinks(newLinks);
  };

  if (loading) {
    return (
      <div className="main-container appearance-settings">
        <div className="admin-layout">
          <div className="admin-container">
            <div className="links-container-admin">
              {/* // map existing links */}
              {/* {account.IsPaying && links.length < 300 ? (
                <AddNewLinkRegular
                  modalOpen={modalOpen}
                  setModalOpen={setModalOpen}
                  setDisplayBlockPicker={setDisplayBlockPicker}
                  setCurrentLinkType={setCurrentLinkType}
                  setShowUpgradeModal={setShowUpgradeModal}
                />
              ) : (
                <div className="link-limitation-reached">
                  <WarningOutlined /> Vous avez atteint votre limite de 15 liens
                  par page.
                </div>
              )} */}
              <div className="loading-links">
                <Spin size="large" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="main-container appearance-settings">
        <div className="admin-layout">
          <div className="admin-container">
            <div className="links-container-admin">
              {account.IsPaying ? (
                <>
                  {links.length < 500 ? (
                    <AddNewLinkRegular
                      modalOpen={modalOpen}
                      setModalOpen={setModalOpen}
                      setDisplayBlockPicker={setDisplayBlockPicker}
                      setCurrentLinkType={setCurrentLinkType}
                      setShowUpgradeModal={setShowUpgradeModal}
                    />
                  ) : (
                    <div className="link-limitation-reached">
                      <WarningOutlined color="#FFF" /> Vous désirez ajouter plus
                      de 500 liens sur votre pages ? Contactez-nous dans le chat
                      :)
                    </div>
                  )}{" "}
                </>
              ) : links.length < 5 ? (
                <AddNewLinkRegular
                  modalOpen={modalOpen}
                  setModalOpen={setModalOpen}
                  setDisplayBlockPicker={setDisplayBlockPicker}
                  setCurrentLinkType={setCurrentLinkType}
                  setShowUpgradeModal={setShowUpgradeModal}
                />
              ) : (
                <div
                  className="link-limitation-reached"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowUpgradeModal(true);
                  }}
                >
                  <WarningOutlined color="#FFF" />
                  Passez en premium pour ajouter plus de 5 liens sur votre page.
                </div>
              )}
              {currentLinks && currentLinks.length > 0 ? (
                <>
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable-1">
                      {(provided) => (
                        <div
                          className="links-list"
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          {currentLinks.map((link, index) => {
                            return (
                              // component link
                              <Draggable
                                key={link.LinkID.toString()}
                                draggableId={link.LinkID.toString()}
                                index={index}
                                // isDragDisabled={loadingIndexes}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    ref={provided.innerRef}
                                    style={getStyle(
                                      provided.draggableProps.style,
                                      snapshot
                                    )}
                                  >
                                    <Pagelink
                                      isAdmin={true}
                                      linkDetails={link}
                                      key={index}
                                      modalEdit={modalEdit}
                                      setRefresh={setRefresh}
                                      refresh={refresh}
                                      setDisplayBlockPicker={
                                        setDisplayBlockPicker
                                      }
                                      setCurrentLinkType={setCurrentLinkType}
                                    />
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}

                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </>
              ) : (
                ""
              )}
              <ModalLinkCreation
                displayBlockPicker={displayBlockPicker}
                setDisplayBlockPicker={setDisplayBlockPicker}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                closeModal={closeModal}
                isEdittingLink={isEdittingLink}
                setEdittingLink={setEdittingLink}
                linkEditDetails={linkEditDetails}
                currentLinks={currentLinks}
                setRefresh={setRefresh}
                refresh={refresh}
                currentLinkType={currentLinkType}
                setCurrentLinkType={setCurrentLinkType}
              />
              <ModalUpgradeLinks
                setShowUpgradeModal={setShowUpgradeModal}
                showUpgradeModal={showUpgradeModal}
                subtitle="Ajoutez plus de 5 liens par page"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
};
export default Blocks;
